import { defineStore } from 'pinia'
import type { SetUserContactRequest } from '@/interface/gen/request'
import { api } from '@/service/api'
import { defineAsyncComponent, ref } from 'vue'
import type { BaseResponse } from '@/interface/gen/types'
import { useDialog } from 'primevue'
import type { DynamicDialogInstance } from 'primevue/dynamicdialogoptions'


export const useContactStore = defineStore('contactStore', () => {

  let contactsDialog: DynamicDialogInstance|undefined

  const contactModalComponent = defineAsyncComponent(
    () => import('@/components/modal/ContactModal.vue'),
  )

  const dialog = useDialog()

  async function setContact(options: SetUserContactRequest): Promise<BaseResponse> {
    return await api.post('/api/private/v1/user/contact/set', options)
  }

  function openContactModal() {
    contactsDialog = dialog.open(contactModalComponent, {
      props: {
        header: 'Укажите контакты',
        modal: true,
        closable: false,
        closeOnEscape: false,
      },
    })
  }

  function closeContactModal() {
    if (contactsDialog) {
      contactsDialog.close()
      contactsDialog = undefined
    }
  }

  return {
    setContact,
    openContactModal,
    closeContactModal,
  }
})
